import React, { Component, MouseEvent } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { StringUtil } from "@eres/core";
import { AppConstants } from "../configApp";

interface Props {
	id: string;
	onDismiss?: () => void;
	onVerify: ( otp: string ) => Promise<() => void>;
	message: string;
	extraMessage?: React.ReactElement;
	otp?: string;
	maxLength: number;
	hideVCode?: boolean;
	hasResend?: boolean;
	onResend?: () => Promise<any>;
	loginId?: string;
	resend_label?: string;
	resend_label_link?: string;
	showPasscodeAnnouncement?: boolean;
	noCredentialSave?: boolean;
}

interface State {
	mobile?: string;
	email?: string;
	otp?: string;
	error?: string;
	isLoading?: boolean;
	isResending?: boolean;
	showAnnouncement?: boolean;
}

class VerifyPopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			otp: this.props.otp,
			showAnnouncement: this.props.showPasscodeAnnouncement === true,
		};
	}

	hide = ( cb?: Function ) => {
		JQModal( "token-verify" ).hide( cb );
	};
	onFormSubmit = ( e: any ) => {
		if ( e ) e.preventDefault();
	};
	hideAnnouncement = () => {
		this.setState( { showAnnouncement: false } );
	};

	render() {
		let { error, isResending, showAnnouncement } = this.state;
		const { hasResend } = this.props;
		return (
			<Popup
				id={ "token-verify" } showCloseButton={ true } onDismiss={ this.props.onDismiss } showIcon={ false }
				clickOutsideToDismiss={ false } modalBodyContainer={ "" }>
				{ showAnnouncement && <>
					<div className="modal-body modal-body-announcement">
						<div className="form-group announcement-title">
							<span className="icon-announcement"/>{ Strings.announcement }
						</div>
						<div className="passcode-content">
							<p>
								{ Strings.otp_to_passcode }
							</p>
							<b>{ Strings.what_is_passcode }</b><br/>
							<p>
								{ Strings.passcode_desc }
							</p>
							<b>{ Strings.benifits_passcode }</b><br/>
							<p>
								{ Strings.passcode_desc2 }
							</p>
						</div>

					</div>
					<div className="modal-footer d-flex justify-content-center">
						<button
							type="button" className="btn btn_1 btn_style1"
							onClick={ this.hideAnnouncement }>{ Strings.continue }
						</button>
					</div>
				</> }
				{ showAnnouncement === false &&
					<form id="passcode" method="post" autoComplete={ "on" } onSubmit={ this.onFormSubmit }>
						<div className="modal-body modal-body-passcode">
							<div className="text-center"><img
								className="mt-3 mb-3"
								src={ `${ AppConstants.rootUrl }assets/img/password.png` }/>
							</div>
							<div className="text-center"><strong>{ Strings.verification }</strong></div>
							<p className="mt-2 text-center passCode-msg">
								{ this.props.message.split( "\n" ).map( ( value, index ) => {
									return <React.Fragment key={ "msg" + index }> { value }
										<br/>
									</React.Fragment>;
								} ) }</p>
							{ this.props.extraMessage }
							{ this.props.hideVCode !== true &&
								<p className="mt-2 text-center passCode-msg">{ Strings.please_enter_the_verification_code }</p>
							}
							<div className="form-group field-style pass-code-control text-center">
								{ this.props.loginId &&
									<input name="username" type="hidden" autoComplete="on" value={ this.props.loginId }/>
								}
								<input
									name={ "password" }
									className="form-control text-center otp-field" placeholder=""
									autoComplete="on"
									value={ this.state.otp ? this.state.otp + "" : "" }
									onChange={ ( e ) => {
										let value = e.target.value;
										let mx = e.target.maxLength;
										if ( mx != null && mx !== -1 ) {
											if ( value && value.length > mx ) {
												value = value.slice( 0, mx );
											}
										}
										this.setState( {
											otp: value
										} );
									} }
									onKeyDown={ e => {
										if ( e.keyCode === 13 ) {
											e.preventDefault();
											this.onVerify();
										}
									} }
									maxLength={ this.props.maxLength }
									type="password"/>
								{ hasResend && <div className="btn-resend">
									{ !isResending && <>
										{ this.props.resend_label + "  " }
										<button onClick={ this.onResend } className={ "" }>
											<i className={ " " + ( isResending ? "animated-refresh" : "" ) } aria-hidden="true"/>
											{ this.props.resend_label_link }
										</button>
									</> }
									{ isResending && <>
										<div className="spinner-border" role="status">
											<span className="sr-only">Loading...</span>
										</div>
									</> }

								</div> }

							</div>
							{ error && <div className={ "alert alert-danger alert-danger-mydld invalid-feedback-otp" }>
								{ error }
							</div> }
							<div className="form-group text-center mb-0">
								<button
									className="btn btn_1 otp-btn"
									type="submit" onClick={ this.onVerify }>
									{ ( this.state.isLoading ) ? <div className="relative spinner-border " role="status">
										<span className="sr-only">Loading...</span>
									</div> : Strings.verify }
								</button>
							</div>
							{ this.props.children }
						</div>
					</form>
				}
			</Popup>
		);
	}

	componentWillUnmount() {
		JQModal( "token-verify" ).hide();
	}

	onVerify = ( e?: MouseEvent<HTMLButtonElement> ) => {
		if ( e ) e.preventDefault();
		if ( this.state.isLoading ) return;
		if ( StringUtil.isEmptyStringOrNull( this.state.otp ) || this.state.otp!.length < 3 ) {
			this.setState( { error: Strings.invalid_otp } );
			return;
		}
		this.setState( { isLoading: true } );
		this.props.onVerify( this.state.otp! ).then( result => {
			this.setState( {
				isLoading: false,
				error: undefined,
			} );
			if ( !this.props.noCredentialSave && window.PasswordCredential && navigator.credentials
				&& navigator.credentials.create ) {
				return navigator.credentials.create( {
					password: {
						id: this.props.loginId,
						password: this.state.otp
					}
				} as any )
				.then( c => {
					if ( c )
						return navigator.credentials.store( c ).then( _x => {
							return Promise.resolve( result );
						} );
					else
						return Promise.resolve( result );
				} )
				.catch( _e => {
					return Promise.resolve( result );
				} );

			} else {
				return Promise.resolve( result );
			}

		} ).then( result => {
			JQModal( "token-verify" ).hide( result );
		} ).catch( e => {
			this.setState( {
				isLoading: false,
				error: e.toString(),
			} );
		} );
	};
	onResend = ( e?: { preventDefault: () => void; } ) => {
		if ( e ) e.preventDefault();
		if ( this.props.onResend ) {
			if ( this.state.isResending ) return;
			this.setState( { isResending: true } );
			this.props.onResend().then( _result => {
				this.setState( {
					isResending: false,
					error: undefined,
				} );
			} ).catch( e => {
				this.setState( {
					isResending: false,
					error: e.toString(),
				} );
			} );
		}
	};

	componentDidMount(): void {
		JQModal( "token-verify" ).show();
	}
}

export default VerifyPopup;
